import React from 'react';
import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { Metadata } from '@thd-olt-component-react/metadata';
import { ReturnForm } from '../components/ReturnForm';
import { PageLayout } from '../components/shared/PageLayout';
import { useReturnStore } from '../stores/returnStore';
export var Returns = function (_a) {
    var customerRole = _a.customerRole, customerType = _a.customerType;
    var isMilitaryExchangeGuest = useReturnStore(function (state) { return state.isMilitaryExchangeGuest; });
    var orderDetailsPath = useReturnStore(function (state) { return state.orderDetailsPath; });
    var nonGuestCrumbs = [
        {
            path: '/myaccount/purchase-history',
            label: 'Purchase History',
        },
        {
            path: orderDetailsPath,
            label: 'Order Details',
        },
        {
            label: 'Return Items',
            path: '/myaccount/start-a-return',
        },
    ];
    var guestCrumbs = [
        {
            path: '/myaccount/guest-order-tracking',
            label: 'Track Your Order',
        },
        {
            label: 'Return Items',
            path: '/myaccount/start-a-return',
        },
    ];
    var crumbs = useAccountCrumbs(isMilitaryExchangeGuest ? guestCrumbs : nonGuestCrumbs);
    return (React.createElement(PageLayout, { crumbs: crumbs, customerRole: customerRole, customerType: customerType, pageTitle: "Return Items" },
        React.createElement(React.Fragment, null,
            React.createElement(Metadata, { title: "The Home Depot" }),
            React.createElement("div", { className: "sui-max-w-3xl" },
                React.createElement(ReturnForm, null)))));
};
Returns.displayName = 'Returns';
